export default [
  {
    "name": "Aberdeen 06-1",
    "is_public": 1,
    "company_name": "Aberdeen Public School District",
    "id": 19405
  },
  {
    "name": "Agar-Blunt-Onida 58-3",
    "is_public": 1,
    "company_name": "Abo School District 58-3",
    "id": 19522
  },
  {
    "name": "Alcester-Hudson 61-1",
    "is_public": 1,
    "company_name": "Alcester Hudson School 61-1",
    "id": 19530
  },
  {
    "name": "Andes Central 11-1",
    "is_public": 1,
    "company_name": "Andes Central School District",
    "id": 19414
  },
  {
    "name": "Arlington 38-1",
    "is_public": 1,
    "company_name": "Arlington School District 38-1",
    "id": 19467
  },
  {
    "name": "Armour 21-1",
    "is_public": 1,
    "company_name": "Armour School District 21-1",
    "id": 19436
  },
  {
    "name": "Avon 04-1",
    "is_public": 1,
    "company_name": "Avon School District 4-1",
    "id": 19398
  },
  {
    "name": "Baltic 49-1",
    "is_public": 1,
    "company_name": "Baltic School District",
    "id": 19493
  },
  {
    "name": "Belle Fourche 09-1",
    "is_public": 1,
    "company_name": "Belle Fourche School District",
    "id": 19411
  },
  {
    "name": "Bennett County 03-1",
    "is_public": 1,
    "company_name": "Bennett County School District",
    "id": 19397
  },
  {
    "name": "Beresford 61-2",
    "is_public": 1,
    "company_name": "Beresford School District",
    "id": 19531
  },
  {
    "name": "Big Stone City 25-1",
    "is_public": 1,
    "company_name": "Big Stone City Sch Dist 25-1",
    "id": 19445
  },
  {
    "name": "Bison 52-1",
    "is_public": 1,
    "company_name": "Bison School District 52-1",
    "id": 19507
  },
  {
    "name": "Bon Homme 04-2",
    "is_public": 1,
    "company_name": "Bon Homme School District 4-2",
    "id": 19399
  },
  {
    "name": "Bowdle 22-1",
    "is_public": 1,
    "company_name": "Bowdle School District 22-1",
    "id": 19438
  },
  {
    "name": "Brandon Valley 49-2",
    "is_public": 1,
    "company_name": "Brandon Valley School District",
    "id": 19494
  },
  {
    "name": "Bridgewater-Emery 30-3",
    "is_public": 1,
    "company_name": "Bridgewater-Emery School District",
    "id": 19484
  },
  {
    "name": "Britton-Hecla 45-4",
    "is_public": 1,
    "company_name": "Britton-Hecla School District",
    "id": 19487
  },
  {
    "name": "Brookings 05-1",
    "is_public": 1,
    "company_name": "Brookings School District 5-1",
    "id": 19401
  },
  {
    "name": "Burke 26-2",
    "is_public": 1,
    "company_name": "Burke School District 26-2",
    "id": 19449
  },
  {
    "name": "Canistota 43-1",
    "is_public": 1,
    "company_name": "Canistota School District 43-1",
    "id": 19481
  },
  {
    "name": "Canton 41-1",
    "is_public": 1,
    "company_name": "Canton School District",
    "id": 19477
  },
  {
    "name": "Castlewood 28-1",
    "is_public": 1,
    "company_name": "Castlewood School District 28-1",
    "id": 19452
  },
  {
    "name": "Centerville 60-1",
    "is_public": 1,
    "company_name": "Centerville School District 60-1",
    "id": 19526
  },
  {
    "name": "Chamberlain 07-1",
    "is_public": 1,
    "company_name": "Chamberlain School District",
    "id": 19409
  },
  {
    "name": "Chester Area 39-1",
    "is_public": 1,
    "company_name": "Chester Area School District",
    "id": 19471
  },
  {
    "name": "Clark 12-2",
    "is_public": 1,
    "company_name": "Clark School District",
    "id": 19417
  },
  {
    "name": "Colman-Egan 50-5",
    "is_public": 1,
    "company_name": "Colman-Egan School District 50-5",
    "id": 19500
  },
  {
    "name": "Colome Consolidated 59-3",
    "is_public": 1,
    "company_name": "Colome School District 59-1",
    "id": 19524
  },
  {
    "name": "Corsica-Stickney 21-3",
    "is_public": 1,
    "company_name": "Corsica-Stickney School District",
    "id": 19437
  },
  {
    "name": "Custer 16-1",
    "is_public": 1,
    "company_name": "Custer School District",
    "id": 19427
  },
  {
    "name": "Dakota Valley 61-8",
    "is_public": 1,
    "company_name": "Dakota Valley School District",
    "id": 19533
  },
  {
    "name": "De Smet 38-2",
    "is_public": 1,
    "company_name": "De Smet School District",
    "id": 19468
  },
  {
    "name": "Dell Rapids 49-3",
    "is_public": 1,
    "company_name": "Dell Rapids School District",
    "id": 19495
  },
  {
    "name": "Deubrook Area 05-6",
    "is_public": 1,
    "company_name": "Deubrook Area School District",
    "id": 19402
  },
  {
    "name": "Deuel 19-4",
    "is_public": 1,
    "company_name": "Deuel School District 19-4",
    "id": 19433
  },
  {
    "name": "Doland 56-2",
    "is_public": 1,
    "company_name": "Doland School Dist 56-2",
    "id": 19518
  },
  {
    "name": "Douglas 51-1",
    "is_public": 1,
    "company_name": "Douglas School District",
    "id": 19502
  },
  {
    "name": "Dupree 64-2",
    "is_public": 1,
    "company_name": "Dupree School District 64-2",
    "id": 21782
  },
  {
    "name": "Eagle Butte 20-1",
    "is_public": 1,
    "company_name": "Eagle Butte School District",
    "id": 19434
  },
  {
    "name": "Edgemont 23-1",
    "is_public": 1,
    "company_name": "Edgemont School District 23-1",
    "id": 19441
  },
  {
    "name": "Edmunds Central 22-5",
    "is_public": 1,
    "company_name": "Edmunds Central Sch Dist 22-5",
    "id": 19440
  },
  {
    "name": "Elk Mountain 16-2",
    "is_public": 1,
    "company_name": "Elk Mountain School Dist 16-2",
    "id": 21829
  },
  {
    "name": "Elk Point-Jefferson 61-7",
    "is_public": 1,
    "company_name": "Elk Point-Jefferson School District 61-7",
    "id": 19532
  },
  {
    "name": "Elkton 05-3",
    "is_public": 1,
    "company_name": "Elkton School District 5-3",
    "id": 19403
  },
  {
    "name": "Estelline 28-2",
    "is_public": 1,
    "company_name": "Estelline School District 28-2",
    "id": 19453
  },
  {
    "name": "Ethan 17-1",
    "is_public": 1,
    "company_name": "Ethan School District 17-1",
    "id": 19428
  },
  {
    "name": "Eureka 44-1",
    "is_public": 1,
    "company_name": "Eureka School District 44-1",
    "id": 19485
  },
  {
    "name": "Faith 46-2",
    "is_public": 1,
    "company_name": "Faith School District 46-2",
    "id": 19490
  },
  {
    "name": "Faulkton Area Schools 24-4",
    "is_public": 1,
    "company_name": "Faulkton Area School District 24-4",
    "id": 19444
  },
  {
    "name": "Flandreau 50-3",
    "is_public": 1,
    "company_name": "Flandreau School District",
    "id": 19501
  },
  {
    "name": "Florence 14-1",
    "is_public": 1,
    "company_name": "Florence School District 14-1",
    "id": 19420
  },
  {
    "name": "Frederick Area 06-2",
    "is_public": 1,
    "company_name": "Frederick Area School Dist 6-2",
    "id": 19407
  },
  {
    "name": "Freeman 33-1",
    "is_public": 1,
    "company_name": "Freeman School District 33-1",
    "id": 19459
  },
  {
    "name": "Garretson 49-4",
    "is_public": 1,
    "company_name": "Garretson School District",
    "id": 19496
  },
  {
    "name": "Gayville-Volin 63-1",
    "is_public": 1,
    "company_name": "Gayville-Volin School District",
    "id": 19536
  },
  {
    "name": "Gettysburg 53-1",
    "is_public": 1,
    "company_name": "Gettysburg School Dist 53-1",
    "id": 19509
  },
  {
    "name": "Gregory 26-4",
    "is_public": 1,
    "company_name": "Gregory School District 26-4",
    "id": 19450
  },
  {
    "name": "Groton Area 06-6",
    "is_public": 1,
    "company_name": "Groton School District",
    "id": 19406
  },
  {
    "name": "Haakon 27-1",
    "is_public": 1,
    "company_name": "Haakon School District 27-1",
    "id": 19451
  },
  {
    "name": "Hamlin 28-3",
    "is_public": 1,
    "company_name": "Hamlin School District",
    "id": 19454
  },
  {
    "name": "Hanson 30-1",
    "is_public": 1,
    "company_name": "Hanson School District 30-1",
    "id": 19456
  },
  {
    "name": "Harding County 31-1",
    "is_public": 1,
    "company_name": "Harding County 31-1",
    "id": 19457
  },
  {
    "name": "Harrisburg 41-2",
    "is_public": 1,
    "company_name": "Harrisburg School District",
    "id": 19478
  },
  {
    "name": "Henry 14-2",
    "is_public": 1,
    "company_name": "Henry School District 14-2",
    "id": 19421
  },
  {
    "name": "Herreid 10-1",
    "is_public": 1,
    "company_name": "Herreid School District 10-1",
    "id": 19413
  },
  {
    "name": "Highmore-Harrold 34-2",
    "is_public": 1,
    "company_name": "Highmore-Harrold School District 34-2",
    "id": 19463
  },
  {
    "name": "Hill City 51-2",
    "is_public": 1,
    "company_name": "Hill City School District",
    "id": 19503
  },
  {
    "name": "Hitchcock-Tulare 56-6",
    "is_public": 1,
    "company_name": "Hitchcock-Tulare Sch Dist 56-6",
    "id": 19394
  },
  {
    "name": "Hot Springs 23-2",
    "is_public": 1,
    "company_name": "Hot Springs School District",
    "id": 19442
  },
  {
    "name": "Hoven 53-2",
    "is_public": 1,
    "company_name": "Hoven School District 53-2",
    "id": 19510
  },
  {
    "name": "Howard 48-3",
    "is_public": 1,
    "company_name": "Howard School District",
    "id": 19492
  },
  {
    "name": "Huron 02-2",
    "is_public": 1,
    "company_name": "Huron School District 2-2",
    "id": 19395
  },
  {
    "name": "Ipswich Public 22-6",
    "is_public": 1,
    "company_name": "Ipswich School District 22-6",
    "id": 19439
  },
  {
    "name": "Irene-Wakonda 13-3",
    "is_public": 1,
    "company_name": "Irene School District 63-2",
    "id": 19537
  },
  {
    "name": "Iroquois 02-3",
    "is_public": 1,
    "company_name": "Iroquois School District",
    "id": 19469
  },
  {
    "name": "Jones County 37-3",
    "is_public": 1,
    "company_name": "Jones County School District 37-3",
    "id": 19466
  },
  {
    "name": "Kadoka Area 35-2",
    "is_public": 1,
    "company_name": "Kadoka Area School District",
    "id": 19464
  },
  {
    "name": "Kimball 07-2",
    "is_public": 1,
    "company_name": "Kimball School District",
    "id": 19410
  },
  {
    "name": "Lake Preston 38-3",
    "is_public": 1,
    "company_name": "Lake Preston School Dist 38-3",
    "id": 19470
  },
  {
    "name": "Langford Area 45-5",
    "is_public": 1,
    "company_name": "Langford Area 45-5 School District",
    "id": 19488
  },
  {
    "name": "Lead-Deadwood 40-1",
    "is_public": 1,
    "company_name": "Lead Deadwood School District",
    "id": 19475
  },
  {
    "name": "Lemmon 52-4",
    "is_public": 1,
    "company_name": "Lemmon School District 52-2",
    "id": 19508
  },
  {
    "name": "Lennox 41-4",
    "is_public": 1,
    "company_name": "Lennox School District",
    "id": 19479
  },
  {
    "name": "Leola 44-2",
    "is_public": 1,
    "company_name": "Leola School District 44-2",
    "id": 19486
  },
  {
    "name": "Lyman 42-1",
    "is_public": 1,
    "company_name": "Lyman School District 42-1",
    "id": 19480
  },
  {
    "name": "Madison Central 39-2",
    "is_public": 1,
    "company_name": "Madison Central School District",
    "id": 19472
  },
  {
    "name": "Marion 60-3",
    "is_public": 1,
    "company_name": "Marion School District",
    "id": 19527
  },
  {
    "name": "McCook Central 43-7",
    "is_public": 1,
    "company_name": "McCook Central School District",
    "id": 19483
  },
  {
    "name": "McIntosh 15-1",
    "is_public": 1,
    "company_name": "Mcintosh School District 15-1",
    "id": 19424
  },
  {
    "name": "McLaughlin 15-2",
    "is_public": 1,
    "company_name": "Mclaughlin School District 15-2",
    "id": 19425
  },
  {
    "name": "Meade 46-1",
    "is_public": 1,
    "company_name": "Meade School District 46-1",
    "id": 19489
  },
  {
    "name": "Menno 33-2",
    "is_public": 1,
    "company_name": "Menno School District 33-2",
    "id": 19460
  },
  {
    "name": "Milbank 25-4",
    "is_public": 1,
    "company_name": "Milbank School District 25-4",
    "id": 19447
  },
  {
    "name": "Miller 29-4",
    "is_public": 1,
    "company_name": "Miller School District",
    "id": 19455
  },
  {
    "name": "Mitchell 17-2",
    "is_public": 1,
    "company_name": "Mitchell School District",
    "id": 19429
  },
  {
    "name": "Mobridge-Pollock 62-6",
    "is_public": 1,
    "company_name": "Mobridge-Pollock School District",
    "id": 19534
  },
  {
    "name": "Montrose 43-2",
    "is_public": 1,
    "company_name": "Montrose School District 43-2",
    "id": 19482
  },
  {
    "name": "Mount Vernon 17-3",
    "is_public": 1,
    "company_name": "Mt Vernon School District 17-3",
    "id": 19430
  },
  {
    "name": "New Underwood 51-3",
    "is_public": 1,
    "company_name": "New Underwood School District",
    "id": 19504
  },
  {
    "name": "Newell 09-2",
    "is_public": 1,
    "company_name": "Newell School District 9-2",
    "id": 19412
  },
  {
    "name": "Northwestern Area 56-7",
    "is_public": 1,
    "company_name": "Northwestern Area School District",
    "id": 19519
  },
  {
    "name": "Oelrichs 23-3",
    "is_public": 1,
    "company_name": "Oelrichs School District 23-3",
    "id": 19443
  },
  {
    "name": "Oglala Lakota County 65-1",
    "is_public": 1,
    "company_name": "Oglala Lakota County School District",
    "id": 196421
  },
  {
    "name": "Oldham-Ramona-Rutland  39-6",
    "is_public": 1,
    "company_name": "Oldham-Ramona-Rutland 39-6",
    "id": 19473
  },
  {
    "name": "Parker 60-4",
    "is_public": 1,
    "company_name": "Parker School District 60-4",
    "id": 19528
  },
  {
    "name": "Parkston 33-3",
    "is_public": 1,
    "company_name": "Parkston School District",
    "id": 19461
  },
  {
    "name": "Pierre 32-2",
    "is_public": 1,
    "company_name": "Pierre School District 32-2",
    "id": 19458
  },
  {
    "name": "Plankinton 01-1",
    "is_public": 1,
    "company_name": "Plankinton School District 1-1",
    "id": 19391
  },
  {
    "name": "Platte-Geddes 11-5",
    "is_public": 1,
    "company_name": "Platte-Geddes School District",
    "id": 19416
  },
  {
    "name": "Rapid City Area 51-4",
    "is_public": 1,
    "company_name": "Rapid City Area Schools",
    "id": 19505
  },
  {
    "name": "Redfield 56-4",
    "is_public": 1,
    "company_name": "Redfield School District",
    "id": 19520
  },
  {
    "name": "Rosholt 54-4",
    "is_public": 1,
    "company_name": "Rosholt School District",
    "id": 19511
  },
  {
    "name": "Sanborn Central 55-5",
    "is_public": 1,
    "company_name": "Sanborn Central 55-5",
    "id": 19515
  },
  {
    "name": "Scotland 04-3",
    "is_public": 1,
    "company_name": "Scotland School District 4-3",
    "id": 19400
  },
  {
    "name": "Selby Area 62-5",
    "is_public": 1,
    "company_name": "Selby Area School Dist 62-5",
    "id": 19535
  },
  {
    "name": "Sioux Falls 49-5",
    "is_public": 1,
    "company_name": "Sioux Falls School District 49-5",
    "id": 19497
  },
  {
    "name": "Sioux Valley 05-5",
    "is_public": 1,
    "company_name": "Sioux Valley School District",
    "id": 19404
  },
  {
    "name": "Sisseton 54-2",
    "is_public": 1,
    "company_name": "Sisseton School District",
    "id": 19512
  },
  {
    "name": "Smee 15-3",
    "is_public": 1,
    "company_name": "Smee School District 15-3",
    "id": 19426
  },
  {
    "name": "South Central 26-5",
    "is_public": 1,
    "company_name": "South Central School District 26-5",
    "id": 19448
  },
  {
    "name": "Spearfish 40-2",
    "is_public": 1,
    "company_name": "Spearfish School District",
    "id": 19476
  },
  {
    "name": "Stanley County 57-1",
    "is_public": 1,
    "company_name": "Stanley County Public Schools",
    "id": 19521
  },
  {
    "name": "Summit 54-6",
    "is_public": 1,
    "company_name": "Summit School District 54-6",
    "id": 19513
  },
  {
    "name": "Tea Area 41-5",
    "is_public": 1,
    "company_name": "Tea Area School District",
    "id": 21919
  },
  {
    "name": "Timber Lake 20-3",
    "is_public": 1,
    "company_name": "Timber Lake School District",
    "id": 19435
  },
  {
    "name": "Todd County 66-1",
    "is_public": 1,
    "company_name": "Todd County 66-1",
    "id": 19523
  },
  {
    "name": "Tri-Valley 49-6",
    "is_public": 1,
    "company_name": "Tri-Valley School District",
    "id": 19498
  },
  {
    "name": "Tripp-Delmont 33-5",
    "is_public": 1,
    "company_name": "Tripp-Delmont School District 33-5",
    "id": 19462
  },
  {
    "name": "Vermillion 13-1",
    "is_public": 1,
    "company_name": "Vermillion School District",
    "id": 19419
  },
  {
    "name": "Viborg-Hurley 60-6",
    "is_public": 1,
    "company_name": "Viborg- Hurley School District",
    "id": 19529
  },
  {
    "name": "Wagner Community 11-4",
    "is_public": 1,
    "company_name": "Wagner Community School District",
    "id": 19415
  },
  {
    "name": "Wall 51-5",
    "is_public": 1,
    "company_name": "Wall School District  51-5",
    "id": 19506
  },
  {
    "name": "Warner 06-5",
    "is_public": 1,
    "company_name": "Warner School District 6-5",
    "id": 19408
  },
  {
    "name": "Watertown 14-4",
    "is_public": 1,
    "company_name": "Watertown School District",
    "id": 19422
  },
  {
    "name": "Waubay 18-3",
    "is_public": 1,
    "company_name": "Waubay School District 18-3",
    "id": 19431
  },
  {
    "name": "Waverly 14-5",
    "is_public": 1,
    "company_name": "Waverly School District",
    "id": 19423
  },
  {
    "name": "Webster Area 18-5",
    "is_public": 1,
    "company_name": "Webster Area School District",
    "id": 19432
  },
  {
    "name": "Wessington Springs 36-2",
    "is_public": 1,
    "company_name": "Wessington Springs School District 36-2",
    "id": 19465
  },
  {
    "name": "West Central 49-7",
    "is_public": 1,
    "company_name": "West Central School District",
    "id": 19499
  },
  {
    "name": "White Lake 01-3",
    "is_public": 1,
    "company_name": "White Lake School District 1-3",
    "id": 19393
  },
  {
    "name": "White River 47-1",
    "is_public": 1,
    "company_name": "White River School District 47-1",
    "id": 19491
  },
  {
    "name": "Willow Lake 12-3",
    "is_public": 1,
    "company_name": "Willow Lake School District 12-3",
    "id": 19418
  },
  {
    "name": "Wilmot 54-7",
    "is_public": 1,
    "company_name": "Wilmot School District 54-7",
    "id": 19514
  },
  {
    "name": "Winner 59-2",
    "is_public": 1,
    "company_name": "Winner School District",
    "id": 19525
  },
  {
    "name": "Wolsey-Wessington 02-6",
    "is_public": 1,
    "company_name": "Wolsey-Wessington Sd 2-6",
    "id": 19396
  },
  {
    "name": "Woonsocket 55-4",
    "is_public": 1,
    "company_name": "Woonsocket School District",
    "id": 19516
  },
  {
    "name": "Yankton 63-3",
    "is_public": 1,
    "company_name": "Yankton School District 63-3",
    "id": 19538
  },
  {
    "name": "Aberdeen Catholic Schools - 06301",
    "is_public": 0,
    "company_name": "ABERDEEN CATHOLIC SCHOOLS",
    "id": 7339
  },
  {
    "name": "Aberdeen Christian School, Inc. - 06320",
    "is_public": 0,
    "company_name": "ABERDEEN CHRISTIAN SCHOOL, INC",
    "id": 213704
  },
  {
    "name": "American Horse School - 03301",
    "is_public": 0,
    "company_name": "American Horse School",
    "id": 209151
  },
  {
    "name": "Baan Dek Montessori - 49335",
    "is_public": 0,
    "company_name": "Baan Dek Montessori - 49335",
    "id": 215328
  },
  {
    "name": "Bethel Lutheran School - 49331",
    "is_public": 0,
    "company_name": "Bethel Lutheran Elementary - 49331",
    "id": 215329
  },
  {
    "name": "Bethesda Lutheran School - 23301",
    "is_public": 0,
    "company_name": "Bethesda Lutheran Elementary - 23301",
    "id": 215330
  },
  {
    "name": "Bishop O'Gorman Catholic Schools - 49303",
    "is_public": 0,
    "company_name": "Bishop O'Gorman Catholic Schools - 49303",
    "id": 215331
  },
  {
    "name": "Black Hills Special Services Cooperative - 40201",
    "is_public": 0,
    "company_name": "Black Hills Special Svc Co-Op",
    "id": 22415
  },
  {
    "name": "Calvary Baptist Christian School - 51321",
    "is_public": 0,
    "company_name": "CALVARY CHRISTIAN SCHOOL",
    "id": 7198
  },
  {
    "name": "Cheyenne River BIE Schools - 20302",
    "is_public": 0,
    "company_name": "Cheyenne River BIE Schools - 20302",
    "id": 19434
  },
  {
    "name": "Chief Gall Alternative - 06901",
    "is_public": 0,
    "company_name": "CHIEF GALL ALTERNATIVE",
    "id": 117336
  },
  {
    "name": "Children's Home Society of South Dakota - 49320",
    "is_public": 0,
    "company_name": "CHILDREN'S HOME SOCIETY LOVING SCHOOL",
    "id": 200085
  },
  {
    "name": "Children's House Montessori - 51331",
    "is_public": 0,
    "company_name": "CHILDREN'S HOUSE MONTESSORI",
    "id": 26573
  },
  {
    "name": "Crazy Horse School - 35301",
    "is_public": 0,
    "company_name": "Crazy Horse School",
    "id": 209198
  },
  {
    "name": "Creekside Christian School - 51303",
    "is_public": 0,
    "company_name": "CREEKSIDE CHRISTIAN SCHOOL",
    "id": 200084
  },
  {
    "name": "Crow Creek Sioux Tribal School - 34301",
    "is_public": 0,
    "company_name": "Crow Creek Sioux Tribal Elem School",
    "id": 209206
  },
  {
    "name": "Dakota Christian School - 21303",
    "is_public": 0,
    "company_name": "DAKOTA CHRISTIAN SCHOOL",
    "id": 24737
  },
  {
    "name": "East Dakota Educational Cooperative - 49203",
    "is_public": 0,
    "company_name": "East Dakota Educational Cooperative",
    "id": 207696
  },
  {
    "name": "Enemy Swim Day School - 18301",
    "is_public": 0,
    "company_name": "Enemy Swim Day School",
    "id": 209242
  },
  {
    "name": "Flandreau Indian School - 50301",
    "is_public": 0,
    "company_name": "Flandreau Indian School",
    "id": 209104
  },
  {
    "name": "For His Glory School - 32306",
    "is_public": 0,
    "company_name": "For His Glory School - 32306",
    "id": 28994
  },
  {
    "name": "Freeman Academy - 33304",
    "is_public": 0,
    "company_name": "FREEMAN ACADEMY",
    "id": 200088
  },
  {
    "name": "Good Shepherd Lutheran School - 49323",
    "is_public": 0,
    "company_name": "GOOD SHEPHERD LUTHERAN",
    "id": 7177
  },
  {
    "name": "Great Plains Lutheran High School - 14309",
    "is_public": 0,
    "company_name": "GREAT PLAINS LUTHERAN HIGH SCHOOL",
    "id": 27256
  },
  {
    "name": "Holy Trinity Catholic School - 02302",
    "is_public": 0,
    "company_name": "Holy Trinity Catholic Elementary - 01",
    "id": 186998
  },
  {
    "name": "Hutterville Colony - 06318",
    "is_public": 0,
    "company_name": "Hutterville Colony High School - 02",
    "id": 215341
  },
  {
    "name": "Immaculate Conception School - 14304",
    "is_public": 0,
    "company_name": "Immaculate Conception Elementary - 01",
    "id": 215342
  },
  {
    "name": "Impact Learning  Development - 51306",
    "is_public": 0,
    "company_name": "Impact Learning & Development - 01",
    "id": 215414
  },
  {
    "name": "Isna Wica Owayawa Loneman School - 65307",
    "is_public": 0,
    "company_name": "Isna Wica Owayawa (Loneman School) - 01",
    "id": 213387
  },
  {
    "name": "James Valley Christian School - 02304",
    "is_public": 0,
    "company_name": "James Valley Christian Elementary - 02",
    "id": 215345
  },
  {
    "name": "LifeScape - 49317",
    "is_public": 0,
    "company_name": "LifeScape Children's Specialty School - 01",
    "id": 215416
  },
  {
    "name": "Little Eagle School District - 15303",
    "is_public": 0,
    "company_name": "LITTLE EAGLE GRANT SCHOOL",
    "id": 214754
  },
  {
    "name": "Little Wound School System - 65306",
    "is_public": 0,
    "company_name": "Little Wound School District",
    "id": 209259
  },
  {
    "name": "Lower Brule Day School - 42301",
    "is_public": 0,
    "company_name": "Lower Brule Day School",
    "id": 209170
  },
  {
    "name": "Madison Christian School - 39304",
    "is_public": 0,
    "company_name": "Madison Christian Elementary - 01",
    "id": 215347
  },
  {
    "name": "Marty Indian School - 11301",
    "is_public": 0,
    "company_name": "Marty Indian School - District",
    "id": 209135
  },
  {
    "name": "McCrossan Boys Ranch - 49329",
    "is_public": 0,
    "company_name": "McCrossan Boys Ranch Elementary - 03",
    "id": 215353
  },
  {
    "name": "Mitchell Christian School - 17310",
    "is_public": 0,
    "company_name": "MITCHELL CHRISTIAN SCHOOL",
    "id": 7336
  },
  {
    "name": "Montessori School of Aberdeen - 06340",
    "is_public": 0,
    "company_name": "Montessori School of Aberdeen Elementary - 01",
    "id": 215358
  },
  {
    "name": "Our Savior Lutheran - 01",
    "is_public": 0,
    "company_name": "Our Savior Lutheran - 01",
    "id": 215360
  },
  {
    "name": "Peace Lutheran School - 05305",
    "is_public": 0,
    "company_name": "Peace Lutheran School - 01",
    "id": 215361
  },
  {
    "name": "Pierre Indian Learning Center - 32301",
    "is_public": 0,
    "company_name": "Pierre Indian Learning Center",
    "id": 209193
  },
  {
    "name": "Pine Ridge School - 65311",
    "is_public": 0,
    "company_name": "Pine Ridge School",
    "id": 209171
  },
  {
    "name": "Poinsett Colony Elementary - 28301",
    "is_public": 0,
    "company_name": "Poinsett Colony Elementary - 01",
    "id": 215362
  },
  {
    "name": "Porcupine Contract School - 65303",
    "is_public": 0,
    "company_name": "Porcupine Day School",
    "id": 209210
  },
  {
    "name": "Rapid City Catholic School System - 51308",
    "is_public": 0,
    "company_name": "Rapid City Catholic School System - 51308",
    "id": 215363
  },
  {
    "name": "Rapid City Christian School - 51320",
    "is_public": 0,
    "company_name": "RAPID CITY CHRISTIAN SCHOOL",
    "id": 25821
  },
  {
    "name": "Red Cloud Indian School - 65301",
    "is_public": 0,
    "company_name": "RED CLOUD INDIAN SCHOOL",
    "id": 89696
  },
  {
    "name": "Rock Creek Grant School - 15302",
    "is_public": 0,
    "company_name": "Rock Creek Grant School",
    "id": 209224
  },
  {
    "name": "Sacred Heart School - 63301",
    "is_public": 0,
    "company_name": "SACRED HEART MIDDLE SCHOOL -",
    "id": 58419
  },
  {
    "name": "Sapa Un Catholic Academy - 66304",
    "is_public": 0,
    "company_name": "Sapa Un Catholic Academy Elementary - 01",
    "id": 215368
  },
  {
    "name": "SD School for the Blind  Visually Impaired-06302",
    "is_public": 0,
    "company_name": "SD SCH FOR THE BLIND & VISUALLY IMPAIRED",
    "id": 207704
  },
  {
    "name": "Sioux Falls Christian School - 49322",
    "is_public": 0,
    "company_name": "",
    "id": 215370
  },
  {
    "name": "Sioux Falls Lutheran School Association - 49330",
    "is_public": 0,
    "company_name": "Sioux Falls Lutheran Elementary - 01",
    "id": 27505
  },
  {
    "name": "Southeastern - 49334",
    "is_public": 0,
    "company_name": "Southeastern - 49334",
    "id": 215424
  },
  {
    "name": "Spark Alternative - 01301",
    "is_public": 0,
    "company_name": "Spark Alternative - 01",
    "id": 215423
  },
  {
    "name": "Spectrum Matters - 14308",
    "is_public": 0,
    "company_name": "Spectrum Matters - 01",
    "id": 215419
  },
  {
    "name": "St. Agnes School - 13301",
    "is_public": 0,
    "company_name": "ST AGNES ELEMENTARY SCHOOL",
    "id": 86888
  },
  {
    "name": "St. Francis Indian School - 66301",
    "is_public": 0,
    "company_name": "St. Francis Indian School",
    "id": 209175
  },
  {
    "name": "St. John Paul II School - 17302",
    "is_public": 0,
    "company_name": "St. John Paul II Elementary - 01",
    "id": 182617
  },
  {
    "name": "St. Joseph Indian School - 07301",
    "is_public": 0,
    "company_name": "ST JOSEPH INDIAN SCHOOL",
    "id": 84875
  },
  {
    "name": "St. Joseph School - 32303",
    "is_public": 0,
    "company_name": "St. Joseph Elementary - 01",
    "id": 186588
  },
  {
    "name": "St. Lawrence School - 25301",
    "is_public": 0,
    "company_name": "ST LAWRENCE SCHOOL",
    "id": 86805
  },
  {
    "name": "St. Martin's Lutheran School - 14303",
    "is_public": 0,
    "company_name": "ST MARTINS LUTHERAN SCHOOL",
    "id": 23259
  },
  {
    "name": "St. Mary's School - Dell Rapids - 49304",
    "is_public": 0,
    "company_name": "ST MARY CATHOLIC SCHOOL",
    "id": 114459
  },
  {
    "name": "St. Paul's Lutheran School - 51309",
    "is_public": 0,
    "company_name": "ST PAULS LUTHERAN SCHOOL",
    "id": 23646
  },
  {
    "name": "St. Thomas More Catholic School - 05304",
    "is_public": 0,
    "company_name": "ST THOMAS MORE CATHOLIC SCHOOL",
    "id": 120419
  },
  {
    "name": "St. Thomas School - 39301",
    "is_public": 0,
    "company_name": "ST THOMAS SCHOOL",
    "id": 87000
  },
  {
    "name": "Sunshine Bible Academy - 29302",
    "is_public": 0,
    "company_name": "SUNSHINE BIBLE ACADEMY",
    "id": 7187
  },
  {
    "name": "Takini School - 64302",
    "is_public": 0,
    "company_name": "Takini School",
    "id": 209229
  },
  {
    "name": "Tiospaye Topa School System - 20303",
    "is_public": 0,
    "company_name": "Tiospaye Topa School",
    "id": 24896
  },
  {
    "name": "Trinity Lutheran School - 06313",
    "is_public": 0,
    "company_name": "TRINITY LUTHERAN SCHOOL",
    "id": 7338
  },
  {
    "name": "Volga Christian School - 05302",
    "is_public": 0,
    "company_name": "VOLGA CHRISTIAN SCHOOL",
    "id": 7173
  },
  {
    "name": "Watertown Christian School - 14301",
    "is_public": 0,
    "company_name": "WATERTOWN CHRISTIAN SCHOOL",
    "id": 23846
  },
  {
    "name": "Westside Christian School - 49339",
    "is_public": 0,
    "company_name": "WESTSIDE CHRISTIAN SCHOOL",
    "id": 29176
  },
  {
    "name": "White Eagle Christian Academy - 66303",
    "is_public": 0,
    "company_name": "White Eagle Elementary - 01",
    "id": 215387
  },
  {
    "name": "Wounded Knee School System - 65302",
    "is_public": 0,
    "company_name": "Wounded Knee District School",
    "id": 209266
  },
  {
    "name": "Zion Lutheran School - Rapid City - 51304",
    "is_public": 0,
    "company_name": "ZION LUTHERAN SCHOOL",
    "id": 7196
  }
]